import React, { useEffect } from "react"
import PropTypes from "prop-types"
import {
  reservationRecapContainer,
  reservationTitle,
  reservationPart6Text,
} from "./reservation-part-6.module.scss"
import {
  ReservationSubContainer,
  ReservationTitle,
} from "../reservation-styled.js"
import { StepIndicator } from "../StepIndicator/step-indicator"
import moment from "moment"
import "moment/locale/fr"

export const ReservationPart6 = ({
  step,
  typesReservationData,
  typeChoisi,
  creneauxGroupes,
  contactInfo,
  stepRefs,
}) => {
  useEffect(() => {
    const element = document.getElementById("validateAppointment")
    element.scrollIntoView({ behavior: "smooth", block: "end" })
  }, [])
  return (
    <ReservationSubContainer className={reservationRecapContainer}>
      <StepIndicator step={step} refs={stepRefs} />
      <ReservationTitle className={reservationTitle}>
        Récapitulatif et validation
      </ReservationTitle>
      <p className={reservationPart6Text}>
        Objet de la réservation :{" "}
        <b>{typesReservationData[typeChoisi].libelle[0].value}</b>
      </p>
      <p className={reservationPart6Text}>Informations de contact :</p>
      <p>
        <b>
          <div>
            {contactInfo.prenom} {contactInfo.nom}
          </div>
          <div>{contactInfo.phone}</div>
          {contactInfo.mail && <div>{contactInfo.mail}</div>}
        </b>
      </p>
      {contactInfo.cases?.map((isChecked, index) => (
        <p key={`case-${index}`}>
          {typesReservationData[typeChoisi].cases_cochables[index].value} :
          {isChecked ? "Oui" : "Non"}
        </p>
      ))}
      {contactInfo.textes?.map((value, index) =>
        value ? (
          <p key={`texte-${index}`}>
            {
              typesReservationData[typeChoisi].textes_supplementaires[index]
                .value
            }{" "}
            : {value}
          </p>
        ) : null
      )}
      <p className={reservationPart6Text}>
        <p>Créneaux : </p>
        {creneauxGroupes.map((creneau, index) => (
          <p key={index}>
            <b>
              {moment(creneau.date).format("dddd Do MMMM YYYY")}
              {" de "}
              {creneau.start} à {creneau.end}
            </b>
          </p>
        ))}
      </p>
      {typesReservationData[typeChoisi] &&
        typesReservationData[typeChoisi].texte_confirmation[0].value !==
          null && (
          <div
            dangerouslySetInnerHTML={{
              __html:
                typesReservationData[typeChoisi].texte_confirmation[0]
                  .processed,
            }}
          />
        )}
      <p className={reservationPart6Text}>
        Informations complémentaires pour votre réservation :
      </p>
      {typesReservationData[typeChoisi] && (
        <div
          dangerouslySetInnerHTML={{
            __html:
              typesReservationData[typeChoisi].texte_commentaire[0].processed,
          }}
        />
      )}
      <p className={reservationPart6Text}>
        Informations relatives au règlement général sur la protection des
        données :
      </p>
      {typesReservationData[typeChoisi] && (
        <div
          dangerouslySetInnerHTML={{
            __html: typesReservationData[typeChoisi].texte_rgpd[0].processed,
          }}
        />
      )}
    </ReservationSubContainer>
  )
}

ReservationPart6.propTypes = {
  step: PropTypes.number,
  typesReservationData: PropTypes.object,
  typeChoisi: PropTypes.string,
  nombrePersonne: PropTypes.number,
  creneauxGroupes: PropTypes.arrayOf(PropTypes.object),
  contactInfo: PropTypes.object,
  stepRefs: PropTypes.arrayOf(PropTypes.shape({ current: PropTypes.any })),
}
